// extracted by mini-css-extract-plugin
export var background = "dJ_y";
export var close = "dJ_kx";
export var content = "dJ_cl";
export var frame = "dJ_ks";
export var menuBackground = "dJ_kv";
export var menuContent = "dJ_kw";
export var open = "dJ_kt";